<div class="container academic-container">
  <!-- Page Header -->
  <div class="page-header">
    <div class="header-content">
      <div class="header-icon">
        <i class="fas fa-book-open"></i>
      </div>
      <div class="header-text">
        <h2 class="page-title">Academic Resources</h2>
        <p class="page-subtitle">Access curriculum, syllabus, and academic materials</p>
      </div>
    </div>
  </div>

  <div class="card shadow-lg">
    <div class="card-body">
      <h5 class="card-title">
        <i class="fas fa-graduation-cap me-2"></i>Academic Documents & Resources
      </h5>
      <hr class="title-divider">

      <div class="col-12">
        <ul class="list-group">
          <li class="list-group-item" *ngFor="let link of academicLinks; let i=index">
            <div class="academic-item-wrapper">
              <div class="academic-icon">
                <i class="fas fa-file-alt"></i>
                <span class="item-number">{{i + 1}}</span>
              </div>
              <div class="academic-content">
                <a [href]="link.filename" target="_blank" class="academic-link">
                  {{link.displayText}}
                </a>
                <span class="academic-meta">
                  <i class="fas fa-download"></i> Click to download or view
                </span>
              </div>
              <div class="academic-actions">
                <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#academicModal'+i">
                  <i class="fas fa-eye"></i> View
                </button>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>

  <!-- Info Cards Section -->
  <div class="row mt-4">
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-primary">
          <i class="fas fa-book"></i>
        </div>
        <h5>Curriculum</h5>
        <p>Comprehensive course structure and academic programs designed for pharmacy education.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-success">
          <i class="fas fa-calendar-check"></i>
        </div>
        <h5>Academic Calendar</h5>
        <p>Stay updated with semester schedules, examination dates, and important academic events.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-info">
          <i class="fas fa-certificate"></i>
        </div>
        <h5>Certifications</h5>
        <p>Information about pharmaceutical certifications and professional development programs.</p>
      </div>
    </div>
  </div>
</div>

<!-- PDF Viewer Modals - Outside container for proper z-index -->
<ng-container *ngFor="let link of academicLinks; let i=index">
  <app-pdf-viewer [title]="link.displayText" [url]="link.filename" [id]="'academicModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>